export default __webpack_public_path__ + "static/media/icons8-npm.8c0606a7.svg";